import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

const soportado = () => typeof window !== 'undefined' && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;

const base64AUint8 = (b64) => {
    const relleno = '='.repeat((4 - (b64.length % 4)) % 4);
    const crudo = atob((b64 + relleno).replace(/-/g, '+').replace(/_/g, '/'));
    return Uint8Array.from([...crudo].map((c) => c.charCodeAt(0)));
};

/**
 * Avisos del navegador (Web Push). Estados: 'verificando' (comprobando este navegador) | 'no-soportado' | 'bloqueado' (el usuario negó el permiso) |
 * 'activado' | 'desactivado'. activar() pide el permiso y registra este navegador en el servidor.
 */
export default function usePushNotificaciones() {
    const [estado, setEstado] = useState(soportado() ? 'verificando' : 'no-soportado');
    const [trabajando, setTrabajando] = useState(false);

    const revisar = useCallback(async () => {
        if (!soportado()) return;
        if (Notification.permission === 'denied') { setEstado('bloqueado'); return; }
        try {
            const reg = await navigator.serviceWorker.getRegistration('/');
            const sub = reg ? await reg.pushManager.getSubscription() : null;
            setEstado(sub && Notification.permission === 'granted' ? 'activado' : 'desactivado');
        } catch { setEstado('desactivado'); }
    }, []);

    useEffect(() => { revisar(); }, [revisar]);

    const activar = useCallback(async () => {
        if (!soportado()) return;
        setTrabajando(true);
        try {
            const permiso = await Notification.requestPermission();
            if (permiso !== 'granted') { setEstado(permiso === 'denied' ? 'bloqueado' : 'desactivado'); return; }
            const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
            await navigator.serviceWorker.ready;
            const { data } = await api.get('/push/clave');
            let sub = await reg.pushManager.getSubscription();
            if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: base64AUint8(data.clave) });
            await api.post('/push/suscribir', sub.toJSON());
            setEstado('activado');
        } catch (e) {
            console.error('No se pudieron activar los avisos del navegador:', e);
            setEstado('desactivado');
        } finally { setTrabajando(false); }
    }, []);

    const desactivar = useCallback(async () => {
        setTrabajando(true);
        try {
            const reg = await navigator.serviceWorker.getRegistration('/');
            const sub = reg ? await reg.pushManager.getSubscription() : null;
            if (sub) {
                await api.post('/push/desuscribir', { endpoint: sub.endpoint }).catch(() => undefined);
                await sub.unsubscribe();
            }
            setEstado('desactivado');
        } finally { setTrabajando(false); }
    }, []);

    return { estado, trabajando, activar, desactivar };
}
